import { FC } from "react";
import { IconProps } from "./types";

export const ArrowNav: FC<IconProps> = ({
  className,
  fill = "#444",
  ...props
}) => (
  <svg
    width="24"
    height="8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M23.933 4 19.4 0v3.267H.8c-.2 0-.4.066-.534.2-.133.2-.2.333-.2.533s.067.4.2.533c.134.134.334.2.534.2h18.6V8l4.533-4z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v8H0z" />
      </clipPath>
    </defs>
  </svg>
);
